import React from 'react';
import Slider from 'react-slick';

import { CustomNextArrow, CustomPrevArrow } from './SliderArrows/SliderArrows'; 

const defaultSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  nextArrow: <CustomNextArrow />, 
  prevArrow: <CustomPrevArrow />, 
  // その他のデフォルト設定
};


export const GenericSlider = ({ settings = {}, children }) => {
  // デフォルトの設定とプロップスから渡された設定をマージ
  const mergedSettings = { ...defaultSettings, ...settings };
  return (
    <Slider {...mergedSettings}>
      {children}
    </Slider>
  );
};
